export default function () {
	return {
		result: null,

		calculate() {
			const height = Number.parseFloat(this.$refs.height.value)
			const width = Number.parseFloat(this.$refs.width.value)
			const length = Number.parseFloat(this.$refs.length.value)
			const isolation = Number.parseFloat(this.$refs.isolation.value)

			if (
				Number.isNaN(height)
				|| Number.isNaN(width)
				|| Number.isNaN(length)
				|| Number.isNaN(isolation)
			) {
				this.result = null

				return
			}

			const m3 = (width * height * length) / 1000000
			const total = (m3 * isolation) * 100

			this.result = Number.parseInt(total.toString())
		},
	}
}
